import { Button, Modal } from 'antd'
import React from 'react'
import { useIdleLogout } from '../hooks/useIdleLogout'
import { useLogout } from '../hooks/useLogout'

export function formatCountdown(totalSeconds: number): string {
  const safeSeconds = Math.max(0, totalSeconds)
  const minutes = Math.floor(safeSeconds / 60)
  const seconds = safeSeconds % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

/**
 * Warns before, and then performs, the inactivity logout. Mounted inside the authenticated
 * tree (see routes/Main.tsx) so it only ever runs for a signed-in user.
 */
export const IdleLogoutModal: React.FC = () => {
  // Single-flight: this timer and a Log Out click can fire in the same millisecond, and
  // whichever loses would otherwise reject with interaction_in_progress (see useLogout).
  // #7665 Phase 2: tells the post-logout landing to explain itself rather than bouncing the
  // user straight back into a sign-in prompt with no reason given.
  const logout = useLogout({ reason: 'inactivity' })

  const { showWarning, secondsRemaining, extendSession } = useIdleLogout(logout)

  return (
    <Modal
      open={showWarning}
      title="Are you still there?"
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={[
        <Button key="stay" type="primary" onClick={extendSession}>
          Stay signed in
        </Button>,
      ]}>
      <p>
        You&apos;ll be signed out in <strong>{formatCountdown(secondsRemaining)}</strong> because of inactivity.
      </p>
    </Modal>
  )
}
